import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const FourierTransformApplications = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Applications of Fourier Transform "
    videos={[
      "https://www.youtube.com/embed/uQ3Qscmw7mo",
      "https://www.youtube.com/embed/Mw6mMCSny8E",
      "https://www.youtube.com/embed/iTCcvXobUVw",
      "https://www.youtube.com/embed/9-3n63llhH8",
      "https://www.youtube.com/embed/Z6gsm1KHJc8",
      "https://www.youtube.com/embed/iboB28bgCNw",
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default FourierTransformApplications;
